import Brand from "./Brand";

export default function Footer() {
  return (
    <footer className="bg-slate-900 text-slate-400 py-12" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-6">
        <div>
          <div className="bg-white inline-block px-3 py-1.5 rounded">
            <Brand size="sm" />
          </div>
          <p className="mt-3 text-sm max-w-sm">
            Specialist in toiletrenovatie. Snel, vakkundig en eerlijke prijzen.
          </p>
        </div>
        <div className="text-sm flex flex-col sm:items-end gap-1">
          <a href="tel:+31615460576" className="text-white font-semibold hover:text-orange-400 transition-colors" data-testid="footer-phone">
            06 154 60 576
          </a>
          <span>De Toiletman</span>
          <span className="text-slate-500">© {new Date().getFullYear()} De Toiletman. Alle rechten voorbehouden.</span>
        </div>
      </div>
    </footer>
  );
}
